import React from 'react'
import { BrowserRouter as Router, Routes, Route, Link, BrowserRouter } from 'react-router-dom';
import dp from '../assets/dp.png'
import card from '../assets/card-1.png'
import searchvec from '../assets/sub.svg'
const MyAccountBookingComp = () => {
  return (
    <>
      <div>
        <div className='md:mt-6   container mx-auto'>
          {/* serach bar */}

          <div className='flex border w-[95%] mx-auto border-gray-200 rounded-full'>
            {/* <i class="fa-solid fa-angles-down text-gray-300  text-2xl -mr-6 z-40 pt-2 pl-6 absolute  "></i> */}
            <img src={searchvec} alt='imgg' className='  ml-3 mt-3 h-[25px] w-[35px]' />
            <input className='w-full ml-3 h-12 bg-[#FBFEFF] rounded-full pl-3 outline-none reltive md:text-base text-xs ' type='text' placeholder='Search a padel court to book' />
            <div className='bg-blue-100 h-12 w-16 pt-2 cursor-pointer rounded-r-full -ml-16'>
              <i class="fa-solid fa-location-crosshairs text-blue-600 ml-4     text-2xl   "></i>

            </div>
          </div>


          {/* account pic password and number */}

          <div className='  w-[95%] mx-auto'>

            <div className='md:flex m-3 justify-between mx-auto border border-gray-300 rounded-xl p-8 md:mt-6'>
              {/* pic name */}
              <div className='pic-name md:flex'>
                <div className='profile-pic flex '>
                  <img src={dp} alt='dp' className=' rounded-full h-[5rem] md:h-[124px] ' />
                  <div className=' h-[33px] w-[33px]  bg-[#e2edfb] rounded-full mt-[3rem] md:mt-20 -ml-7 '>
                    <input type="file" id="bizimg" class="shadow-sm px-4 hidden h-[40px]  border border-gray-300 text-gray-900 text-xs rounded-2xl   h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />

                    <label htmlFor="bizimg" className='text-[12px] bg-[#e2edfb]   cursor-pointer ml-[10px]  mt-[10px]  h-8 w-8 rounded-full text-[#6A7D95] text-center  ' ><i class="fa-solid fa-pencil text-blue-500 cursor-pointer  text-base mt-[3px] "  ></i></label>
                  </div>
                </div>
                <div className='name  md:pl-3  flex md:justify-center md:items-center '>
                  <div>
                    <h1 className='text-2xl   text-[#272C34] font-bold'>John Doe</h1>
                    <p className='text-[#6A7D95] text-[12px] '>Johndoe@gmail.com</p>
                  </div>
                  <div>
                    <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                  </div>
                </div>
              </div>

              {/* Phone number  */}

              <div className='phone pt-4 num flex'>
                <div className='name  md:pl-3  flex md:justify-center md:items-center '>
                  <div>
                    <h1 className='text-2xl   text-[#272C34] font-bold'>Phone Number</h1>
                    <p className='text-[#6A7D95] text-[12px] '>+000 0000 0000</p>
                  </div>
                  <div>
                    <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                  </div>
                </div>
              </div>

              {/* password */}


              <div className='password  pt-4 flex'>

                <div className='name  md:pl-3  flex md:justify-center md:items-center '>
                  <div>
                    <h1 className='text-2xl   text-[#272C34] font-bold'>Password</h1>
                    <p className='text-[#6A7D95] text-[12px] '>*******************</p>
                  </div>
                  <div>
                    <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                  </div>
                </div>
              </div>


            </div>
          </div>

          {/* My booking in account */}

          <div className='main md:w-[90%]  mx-auto'>
            <div className='account-wrap lg:flex md:flex'>



              <div className='md:w-[20%] w-[60%] '>
                <div className='ml-3'>
                  <h1 className='text-2xl text-[#272C34] font-bold'>Profile</h1>
                  <p className='text-[#409BF5] cursor-pointer py-1 text-lg  '> <Link to="/MyAccount" >My Bookings</Link> </p>
                  <p className='text-gray-500 cursor-pointer py-1 text-lg  '><Link to="/MyAccPayment" > Payment method </Link></p>
                  <p className='text-gray-500 cursor-pointer py-1 text-lg  '><Link to="/Notifi" > Notification </Link></p>
                </div>
              </div>

              <div className='w-full'>
                <div>
                  <h1 className='text-2xl ml-2  text-[#272C34] font-bold'>My Bookings</h1>
                  <div className=' lg:flex md:flex my-4 '>
                    <div className='mybookings-img  '>
                      <img src={card} alt='img' className=' md:w-full w-[90%] mx-auto  ' />
                    </div>
                    <div className='w-full'>                            {/* search result cards */}
                      <div className=' w-full'>



                        <div className='card-text mx-4'>
                          <h1 className='text-2xl text-[#272C34] font-bold py-1'>Padel Buddy Court name</h1>

                          <h2 className='pt-3 text-[#272C34] text-[12px]'><strong>Location</strong></h2>
                          <p className='text-[#6A7D95] text-[12px] font-semibold py-2'>12 ABC London , New York London.</p>
                          <h2 className='pt-3 text-[#272C34] text-[12px] py-2'><strong>Schedule</strong></h2>
                          <p className='text-[#6A7D95] font-semibold text-[12px] '>Monday  -  11:00 AM - 03:00 PM</p>

                          <div className='flex w-full mt-4'>
                            <button className='w-full bg-blue-100 rounded-lg py-3 px-8 text-[14px]  mx-3 text-[#409BF5] font-bold'><a href='' >Contact representative</a> </button>
                            <button className='w-full py-3 mx-3 text-[#409BF5] text-[14px] font-bold'><a href='' >Download Receipt</a> </button>
                            <button className='w-full  py-3 mx-3 text-[#EB5757] text-[14px] font-bold'><a href='' >Cancel Booking</a> </button>
                          </div>
                        </div>
                      </div></div>
                  </div>
                </div>
              </div>








            </div>
          </div>



        </div>
      </div>
    </>
  )
}

export default MyAccountBookingComp